export default __webpack_public_path__ + "static/Artboard-5-8d1ff6aacaf1bfc56be43599203579e0.webp";